import { render, staticRenderFns } from "./information-request.vue?vue&type=template&id=1d65665c"
import script from "./information-request.vue?vue&type=script&lang=js"
export * from "./information-request.vue?vue&type=script&lang=js"
import style0 from "./information-request.vue?vue&type=style&index=0&id=1d65665c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports